import { getSourceCharacters } from './characters';

export function getDialogueItemsForCharacter(caseConf, characterKey, type = null) {
  const characters = getSourceCharacters(caseConf);
  const selectedCharacter = characters.find(char => char.key === characterKey);
  if (selectedCharacter) {
    const selectedCharacterDialogue = selectedCharacter.dialogue || {};
    if (type) {
      return selectedCharacterDialogue[type] || [];
    }
    const aiQuestions = selectedCharacterDialogue.aiQuestions || [];
    const aiUnsolicited = selectedCharacterDialogue.aiUnsolicited || [];
    return [...aiQuestions, ...aiUnsolicited];
  }
  else {
    return [];
  }
}